import { render, staticRenderFns } from "./BusinessCard.vue?vue&type=template&id=56adf69a&scoped=true&"
import script from "./BusinessCard.vue?vue&type=script&lang=js&"
export * from "./BusinessCard.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCard.vue?vue&type=style&index=0&id=56adf69a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56adf69a",
  null
  
)

export default component.exports